// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetRecommendationsResponseV2Schema } from '../../../entities/recommendations/GetRecommendationsResponseV2Schema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export interface IMobileSiteGetRecommendationsRequest {
  /** Тип лэндинга **/
  landingType: EQueryParameters;
  /** Id региона пользователя **/
  regionId: number;
}

export enum EQueryParameters {
  /** Снять — квартиру на долгий срок **/
  'FlatRent' = 'flatRent',
  /** Посуточно — снять квартиру посуточно **/
  'FlatRentForDay' = 'flatRentForDay',
  /** Главная cian.ru **/
  'MainPage' = 'mainPage',
  /** Купить — квартиру во вторичке **/
  'SecondaryFlatSale' = 'secondaryFlatSale',
  /** Загородка — купить дом, дачу, таунхаус, участок **/
  'SuburbanSale' = 'suburbanSale',
}
export type IMobileSiteGetRecommendationsResponse200 = FetchModelResponse<
  200,
  'json',
  IGetRecommendationsResponseV2Schema
>;

export type IMobileSiteGetRecommendationsResponse400 = FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TMobileSiteGetRecommendationsResponse =
  | IMobileSiteGetRecommendationsResponse200
  | IMobileSiteGetRecommendationsResponse400;

export type TMobileSiteGetRecommendationsModel = IFetchModel<
  IMobileSiteGetRecommendationsRequest,
  undefined,
  TMobileSiteGetRecommendationsResponse
>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetRecommendationsResponseV2Schema, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
